import { TListResponse } from '.';
import {
  Client,
  ClientAddress,
  ClientName,
  ClientProgram,
  TClientId,
  TCountryId,
  TProgramId,
  TRegionId,
  TReportingPeriodTypeId,
  TRoleId,
  User,
} from '/src/lib/models';
import {
  DateString,
  Nullable,
  ProgramCommissionDataForm,
  ReferralCommissionDataForm,
  SalesCommissionDataForm,
} from '/src/lib/types';

/**
 * List Clients
 */
export type TListClientsRequest = {
  limit?: number;
  page?: number;
  name?: string;
  is_active?: boolean;
  order_by?: 'name' | 'start_date';
  order_direction?: 'asc' | 'desc';
};

export type TListClientsResponse = TListResponse<Client[]>;

/**
 * List Client Addresses
 */
export type TListClientAddressesResponse = ClientAddress[];

/**
 * List Client Names
 */
export type TListClientNamesRequest = {
  program_ids?: TProgramId[];
  start_reporting_quarter?: DateString;
};

export type TListClientNamesResponse = ClientName[];

/**
 * List Client Programs
 */
export type TListClientProgramsRequest = {
  id: TClientId;
  reporting_period_type_id?: TReportingPeriodTypeId;
  start_reporting_quarter?: DateString;
  end_reporting_quarter?: DateString;
  program_region_id?: TRegionId;
};

export type TListClientProgramsResponse = ClientProgram[];

/**
 * List Client Users
 */
export type TListClientUsersRequest = {
  id: TClientId;
  page?: number;
  name?: string;
  role_id?: TRoleId;
  is_active?: boolean;
};

export type TListClientUsersResponse = TListResponse<User[]>;

/**
 * Get Client
 */
export type TGetClientRequest = {
  id: TClientId;
};

export type TGetClientResponse = Client;

/**
 * Create Client
 */
export type TCreateClientRequest = {
  name: string;
  start_date: DateString;
  website: Nullable<string>;
  business_id: Nullable<string>;
  first_active_reporting_quarter: DateString;
  jumpstart_amount: Nullable<string>;
  comments: Nullable<string>;
  hq_address_line1: string;
  hq_address_line2: Nullable<string>;
  hq_address_city: string;
  hq_address_region_id: TRegionId;
  country_id: TCountryId;
  hq_address_post_code: string;
  programs: ProgramCommissionDataForm[];
  sales_commission_rates?: SalesCommissionDataForm[];
  referral_commission_rates?: ReferralCommissionDataForm[];
};

export type TCreateClientResponse = Client;

/**
 * Update Client
 */
export type TUpdateClientRequest = {
  id: TClientId;
  name: string;
  website: Nullable<string>;
  business_id: string;
  jumpstart_amount: Nullable<string>;
  comments: Nullable<string>;
  hq_address_line1: string;
  hq_address_line2: Nullable<string>;
  hq_address_city: string;
  hq_address_region_id: TRegionId;
  hq_address_post_code: string;
};

export type TUpdateClientResponse = Client;

/**
 * Retire Client
 */
export type TRetireClientRequest = {
  id: TClientId;
  last_active_reporting_quarter: DateString;
  end_date: DateString;
  retirement_reason: string;
};
